import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'normalizeWhitespace',
    standalone: false
})
export class NormalizeWhitespacePipe implements PipeTransform {

  transform(text: string | null | undefined): string {
    if (!text) return '';
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, 'text/html');

    const cleanTextNodes = (node: Node) => {
      node.childNodes.forEach(child => {
        if (child.nodeType === Node.TEXT_NODE && child.nodeValue) {
          child.nodeValue = child.nodeValue
            .replace(/\u00A0/g, ' ')
            .replace(/\s+/g, ' ');
        } else if (child.nodeType === Node.ELEMENT_NODE) {
          cleanTextNodes(child);
        }
      });
    };
    cleanTextNodes(doc.body);

    return doc.body.innerHTML.trim();
  }

}
